import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SaleTypeEnum } from '@classifieds-sell/datalayer';
import { TimeFromNumberPipe } from '@classifieds-sell/shared';
import { DateTimeFormatterPipe } from '@trademe/tangram';
import { ListingDurationService } from 'libs/property-ui/src/lib/services/listing-duration.service';
import { Subject } from 'rxjs';
import { StepIds } from '../../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../../property-section-base';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'new-homes-property-summary-page-sale-details-section',
    templateUrl: './new-homes-summary-page-sale-details-section.component.html',
    styleUrls: ['./new-homes-summary-page-sale-details-section.component.scss'],
    standalone: false
})
export class NewHomesSummaryPageSaleDetailsSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    saleType: string;
    expectedSalePrice: string;
    endDate: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _dateTimeFormatterPipe: DateTimeFormatterPipe,
        private _datePipe: DatePipe,
        private _timeFromNumberPipe: TimeFromNumberPipe,
        private _listingDurationService: ListingDurationService
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            if (
                this.draftData.propertyInformation.propertyPriceType ===
                SaleTypeEnum.askingPrice
            ) {
                this.saleType = `Asking price $${(
                    this.draftData.propertyInformation.propertyPricePrice || 0
                ).toLocaleString()}`;
            }

            if (
                this.draftData.propertyInformation.propertyPriceType ===
                SaleTypeEnum.enquiriesOver
            ) {
                this.saleType = `Enquiries over $${(
                    this.draftData.propertyInformation.propertyPricePrice || 0
                ).toLocaleString()}`;
            }

            if (
                this.draftData.propertyInformation.propertyPriceType ===
                SaleTypeEnum.auction
            ) {
                let auctionTime = null;
                if (this.draftData.propertyInformation.auctionTime) {
                    auctionTime = this._timeFromNumberPipe.transform(this.draftData.propertyInformation.auctionTime);
                }
                this.saleType = `To be auctioned on ${this._datePipe.transform(
                    this.draftData.propertyInformation.propertyPriceDate,
                    'dd/MM/yyyy'
                )}${auctionTime ? ', ' + auctionTime : ''}`;
            }

            if (
                this.draftData.propertyInformation.propertyPriceType ===
                SaleTypeEnum.tender
            ) {
                this.saleType = `Tenders closing on ${this._datePipe.transform(
                    this.draftData.propertyInformation.propertyPriceDate,
                    'dd/MM/yyyy'
                )}`;
            }

            if (
                this.draftData.propertyInformation.propertyPriceType ===
                SaleTypeEnum.priceByNegotiation
            ) {
                this.saleType = 'Price by negotiation';
            }

            if (
                this.draftData.propertyInformation.propertyPriceType ===
                SaleTypeEnum.deadlinePrivateTreaty
            ) {
                this.saleType = `Deadline sale by ${this._datePipe.transform(
                    this.draftData.propertyInformation.propertyPriceDate,
                    'dd/MM/yyyy'
                )}}`;
            }

            if (this.draftData.propertyInformation.propertySalePrice) {
                this.expectedSalePrice = `$${(
                    this.draftData.propertyInformation.propertySalePrice || 0
                ).toLocaleString()}`;
            }

            const duration = this.draftData.propertyInformation.duration;
            if (duration) {
                const futureDate = this._listingDurationService.availableDateText(this.metadata, duration);
                this.endDate = this._dateTimeFormatterPipe.transform(
                    futureDate,
                    { format: 'short' }
                );
            } else {
                this.endDate = this._dateTimeFormatterPipe.transform(
                    this.metadata.listingEndDate,
                    { format: 'short' }
                );
            }

            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
